import axios from "axios";
import { BASE_END_POINT } from "../../urls";
import { message } from "antd";

// Function to get interest History
export const getInterestHistoryApi = async (id, token, isRTL) => {
    try {
        const response = await axios.get(`${BASE_END_POINT}interests/${id}/getHistory`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en',
            }
        });
        return response.data;
    } catch (error) {
        console.log(error.response)
    }

};
// Function to delete
export const deleteApi = async (id, token, isRTL, allStrings) => {
    let l = message.loading('Wait..', 2.5);
    try {
        const response = await axios.delete(`${BASE_END_POINT}interests/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en',
            },
        });
        l.then(() => message.success(allStrings.done, 2.5));
        return response.data;
    } catch (error) {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    }

};
// Function to update status
export const assignedToApi = async (id, assignedToId, token, isRTL, allStrings) => {
    let l = message.loading('Wait..', 2.5);
    try {
        const response = await axios.put(`${BASE_END_POINT}interests/${id}/assignTo/${assignedToId}`, { assignedTo: assignedToId }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en'
            },
        });
        l.then(() => message.success(allStrings.done, 2.5));
        return response.data;
    } catch (error) {
        console.log(error.response)
        if (error.response.data.errors[0].msg) {
            l.then(() => message.error(error.response.data.errors[0].msg, 2.5))
        } else {
            l.then(() => message.error(allStrings.error, 2.5))
        }
    }
};
// Function to assign To
export const updateStatusApi = async (modalType, state, id, token, isRTL, allStrings) => {
    let l = message.loading('Wait..', 2.5);
    try {
        if (state.followUpStatus === "ANOTHER-CALL-SCHEDULED" && !state.nextContactDate) {
            l.then(() => message.error(allStrings.nextContactDateRequired, 2.5))
        }
        if (state.followUpStatus === "VISIT-SCHEDULED" && !state.visitingDate) {
            l.then(() => message.error(allStrings.visitingDateRequired, 2.5))
        }
        if (state.followUpStatus === "VISIT-SCHEDULED" && !state.visitingEmployee) {
            l.then(() => message.error(allStrings.visitingEmployeeRequired, 2.5))
        }
        if (modalType === "VISIT" && !state.visitnigStatus) {
            l.then(() => message.error(allStrings.visitingStatusRequired, 2.5))
        }
        let url = `${BASE_END_POINT}interests/${id}/contact`
        let data = {
            clientType: state.clientType,
            clientStatus: state.clientStatus,
            followUpStatus: state.followUpStatus,
            noteDescription: state.noteDescription,
            currentProject: state.currentProject
        }

        if (state.followUpStatus === "ANOTHER-CALL-SCHEDULED") {
            data.nextContactDate = state.nextContactDate
        }
        if (state.followUpStatus === "VISIT-SCHEDULED") {
            data.visitingDate = state.visitingDate
            data.visitingEmployee = state.visitingEmployee
        }
        if (state.priceFrom && state.priceTo && state.followUpStatus === "DIFFERENT-REQUEST") {
            data.priceFrom = state.priceFrom
            data.priceTo = state.priceTo
            data.city = state.city
            if (state.area != null) data.area = state.area
            if (state.bedrooms) data.bedrooms = state.bedrooms
            if (state.firstHousing) data.firstHousing = state.firstHousing
            data.category = state.category
            data.subCategory = state.subCategory
            data.direction = state.direction
        }
        if (modalType == "VISIT") {
            data.visitingReport = state.noteDescription
            data.visitnigStatus = state.visitnigStatus
            url = `${BASE_END_POINT}interests/${id}/visitingReport`
        }
        const response = await axios.put(url, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en'
            },
        });
        l.then(() => message.success(allStrings.done, 2.5));
        return response.data;
    } catch (error) {
        console.log(error.response)
        if (error.response.data.errors[0].msg) {
            l.then(() => message.error(error.response.data.errors[0].msg, 2.5))
        } else {
            l.then(() => message.error(allStrings.error, 2.5))
        }
    }
};